@if (data) {
  @if (title) {
    <h5 class="h5 mbxl text-center">{{ title }}</h5>
  }
  <div class="tax-reduction-container">
    <div class="tax-reduction-item">
      <span class="title">{{ prefixedTypeBefore }}</span>
      <div class="data-container">
        <div class="data-item">
          <span class="tax-label">Impôts sur le revenu</span>
          <span class="tax-value">{{
            amount | currency: 'EUR' : 'symbol' : '.2'
          }}</span>
        </div>
      </div>
      <div class="inner-bg"></div>
    </div>
    <div class="tax-reduction-item">
      <span class="title">{{ prefixedTypeAfter }}</span>
      <div class="data-container">
        <div class="data-item reduction">
          <span class="tax-label">Réduction d'impôts</span>
          <span class="tax-value"
            >{{ reduction | currency: 'EUR' : 'symbol' : '.2' }}
          </span>
        </div>
        <div class="data-item">
          <span class="tax-label">Impôts restants</span>
          <span class="tax-value">{{
            calcRemaining | currency: 'EUR' : 'symbol' : '.2'
          }}</span>
        </div>
      </div>
      <div
        class="inner-bg"
        [style.top.px]="218 - calculRate"
        [style.height.px]="calculRate"
      ></div>
    </div>
  </div>
}
